var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PowerRewriteMain',{ref:"mainHeight"}),_c('div',[_c('PowerRewriteContent')],1),_c('v-footer',{attrs:{"inset":"","padless":""}},[_c('YA_footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }